import { AlertOctagon, ArrowRight, Trophy } from "lucide-react";
import { PageHeading } from "../components/PageHeading";
import { usePortal } from "../context/PortalContext";

export function OutcomesPage() {
  const { track } = usePortal();
  if (!track) return <div className="loading-state">正在读取达标结果</div>;
  return (
    <>
      <PageHeading number="07" title="达标结果与成长作用" description="结业代表受控的模拟分析与执行能力，不代表盈利承诺、实盘授权或职业交易员资格。" />
      <section className="capability-flow">
        {track.curriculum.completion_capabilities.length ? track.curriculum.completion_capabilities.map((item, index) => <div key={item}><span>{String(index + 1).padStart(2, "0")}</span><p>{item}</p>{index < track.curriculum.completion_capabilities.length - 1 && <ArrowRight size={18} />}</div>) : <div className="empty-state">当前轨道尚未声明结业能力。</div>}
      </section>
      <section className="section-block">
        <div className="section-title-row"><div><span className="section-number">07.1</span><h2>对你的成长可能产生什么作用</h2></div><Trophy size={23} /></div>
        <div className="growth-grid">{track.curriculum.growth_outcomes.length ? track.curriculum.growth_outcomes.map((item, index) => <article key={item.title}><span>{String(index + 1).padStart(2, "0")}</span><h3>{item.title}</h3><p>{item.effect}</p></article>) : <div className="empty-state">当前轨道尚未声明成长结果。</div>}</div>
      </section>
      <section className="boundary-band">
        <div><AlertOctagon size={25} /><h2>仍然不能证明</h2></div>
        {track.curriculum.boundaries.length ? <ul>{track.curriculum.boundaries.map((item) => <li key={item}>{item}</li>)}</ul> : <div className="empty-state">当前轨道尚未声明结果边界。</div>}
      </section>
    </>
  );
}
